module.exports = __webpack_public_path__ + "img/mizhi-back-cp.b6cd792e.png";